import { AnyAction } from "redux";
import { CREATE_VENDOR_FAILURE, CREATE_VENDOR_REQUEST, CREATE_VENDOR_SUCCESS, GET_VENDOR_FAILURE, GET_VENDOR_REQUEST, GET_VENDOR_SUCCESS } from "../constants/vendors.constants";
const initialState = {
    loading: false,
    data: [],
    error: '',
    count: 0,
    createdVendor: {
        loading: false,
        data: [],
        error: '',
    },

};

export const vendorListReducer = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case CREATE_VENDOR_REQUEST:
            return {
                ...state,
                createdVendor: {
                    ...state.createdVendor,
                    loading: true,
                    error: '',
                    data: [],
                },
            };
        case CREATE_VENDOR_SUCCESS:
            return {
                ...state,
                createdVendor: {
                    ...state.createdVendor,
                    loading: false,
                    data: action.payload,
                },
            };
        case CREATE_VENDOR_FAILURE:
            return {
                ...state,
                createdVendor: {
                    ...state.createdVendor,
                    loading: false,
                    data: [],
                    error: action.payload,
                },
            };
        case GET_VENDOR_REQUEST:
            return {
                ...state,
                loading: true,
            };

        case GET_VENDOR_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                errorMsg: '',
            };
        case GET_VENDOR_FAILURE:
            return {
                ...state,
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
}